import { useState } from 'react';

const faqItems = [
  {
    question: '免费91网页的官方入口是什么？如何确保访问的是官方网站？',
    answer: '免费91网页的官方入口可通过搜索引擎搜索"免费91网页官方"找到。为确保访问安全，请注意核对网址是否正确，查看浏览器地址栏是否有安全锁图标，并避免点击来路不明的链接。官方页面底部会有完整的备案信息和版权声明。',
  },
  {
    question: '免费91网页是否需要注册才能使用？',
    answer: '部分核心功能无需注册即可直接体验。但为了享受完整的功能服务——包括个性化设置、历史记录保存、云存储等功能——建议免费注册一个账号。注册过程简单快捷，只需提供基本的邮箱信息即可完成。',
  },
  {
    question: '手机端如何访问免费91网页？有专门的APP吗？',
    answer: '目前免费91网页可以通过手机浏览器直接访问，页面针对移动端进行了全面适配。在手机浏览器中输入官方网址即可使用全部功能。你还可以通过浏览器菜单将网页添加到手机桌面，方便下次快速访问。',
  },
  {
    question: '免费91网页有哪些核心功能？',
    answer: '免费91网页提供丰富的在线工具和功能，包括文档格式转换、图片处理编辑、数据分析工具、文件压缩合并等。此外还有云存储、协作分享、AI智能助手等高级功能。所有工具均可在浏览器中直接使用，无需下载安装。',
  },
  {
    question: '使用免费91网页安全吗？上传的文件会不会泄露？',
    answer: '免费91网页非常重视用户数据安全。平台采用多重加密技术保护数据传输和存储安全。上传的文件仅用于处理目的，处理完成后会在一定时间内自动从服务器删除。建议不要上传包含敏感个人信息的文件。',
  },
  {
    question: '遇到访问异常或功能无法使用怎么办？',
    answer: '首先尝试清除浏览器缓存和Cookie后重新访问。如果问题仍在，检查网络连接是否稳定。你也可以尝试更换浏览器（推荐Chrome或Edge最新版）。如果以上方法均无效，可通过官方网站的反馈渠道提交问题，技术团队会尽快处理。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            常见问题解答
          </h2>
          <p className="text-foreground-600 text-base">
            这里整理了用户最常问的问题，帮助你快速找到答案
          </p>
        </div>
        <div className="flex flex-col gap-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-5 py-4 flex items-center justify-between gap-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800">
                  {item.question}
                </span>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-600"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}